var _g, _rect, _path, _rect2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPl2Waves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1602_222)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#0055FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12L44 28L28 44L12 28L28 12Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 39,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F88545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5646 42.5575C39.4089 42.7132 39.1418 42.7605 38.9861 42.6048L38.3096 41.9284C38.1385 41.7573 37.8611 41.7573 37.69 41.9284L37.0136 42.6048C36.8579 42.7605 36.5907 42.7132 36.435 42.5575C35.9165 42.0389 35.0757 42.0389 34.5572 42.5575C34.0387 43.076 34.0387 43.9167 34.5572 44.4352C34.7129 44.5909 34.7603 44.8581 34.6046 45.0138L33.9281 45.6902C33.757 45.8613 33.757 46.1388 33.9281 46.3099L34.6046 46.9863C34.7603 47.142 35.0274 47.0946 35.1831 46.9389C35.7017 46.4204 36.5424 46.4204 37.0609 46.9389C37.5795 47.4575 37.5794 48.2982 37.0609 48.8167C36.9052 48.9724 36.8579 49.2396 37.0136 49.3953L37.69 50.0717C37.8611 50.2428 38.1385 50.2428 38.3096 50.0717L38.9861 49.3953C39.1418 49.2396 39.4089 49.2869 39.5646 49.4426C40.0832 49.9612 40.9239 49.9612 41.4424 49.4426C41.9609 48.9241 41.9609 48.0834 41.4424 47.5649C41.2867 47.4092 41.2393 47.142 41.395 46.9863L42.0715 46.3099C42.2426 46.1388 42.2426 45.8613 42.0715 45.6902L41.395 45.0138C41.2393 44.8581 41.2867 44.5909 41.4424 44.4352C41.9609 43.9167 41.9609 43.076 41.4424 42.5575C40.9239 42.0389 40.0832 42.0389 39.5646 42.5575Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 39,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F88545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5646 42.5575C19.4089 42.7132 19.1418 42.7605 18.9861 42.6048L18.3096 41.9284C18.1385 41.7573 17.8611 41.7573 17.69 41.9284L17.0136 42.6048C16.8579 42.7605 16.5907 42.7132 16.435 42.5575C15.9165 42.0389 15.0757 42.0389 14.5572 42.5575C14.0387 43.076 14.0387 43.9167 14.5572 44.4352C14.7129 44.5909 14.7603 44.8581 14.6046 45.0138L13.9281 45.6902C13.757 45.8613 13.757 46.1388 13.9281 46.3099L14.6046 46.9863C14.7603 47.142 15.0274 47.0946 15.1831 46.9389C15.7017 46.4204 16.5424 46.4204 17.0609 46.9389C17.5795 47.4575 17.5794 48.2982 17.0609 48.8167C16.9052 48.9724 16.8579 49.2396 17.0136 49.3953L17.69 50.0717C17.8611 50.2428 18.1385 50.2428 18.3096 50.0717L18.9861 49.3953C19.1418 49.2396 19.4089 49.2869 19.5646 49.4426C20.0832 49.9612 20.9239 49.9612 21.4424 49.4426C21.9609 48.9241 21.9609 48.0834 21.4424 47.5649C21.2867 47.4092 21.2393 47.142 21.395 46.9863L22.0715 46.3099C22.2426 46.1388 22.2426 45.8613 22.0715 45.6902L21.395 45.0138C21.2393 44.8581 21.2867 44.5909 21.4424 44.4352C21.9609 43.9167 21.9609 43.076 21.4424 42.5575C20.9239 42.0389 20.0832 42.0389 19.5646 42.5575Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1602_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl2Waves);
export default __webpack_public_path__ + "static/media/PL2WAVES.804f9e6fee50fad2afe9386d69fd3c2c.svg";
export { ForwardRef as ReactComponent };